import { useContext } from "react";

import GetIcon from "Components/Global/Icons";

import { TableContext } from "../..";
import * as S from "../../styles";

const TableFooter = () => {
  const {
    preGlobalFilteredRows,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useContext(TableContext);

  return (
    <S.TableFooter>
      <S.TableFooterRow>
        Você está vendo{" "}
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[5, 10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {pageSize}
            </option>
          ))}
        </select>{" "}
        de {preGlobalFilteredRows.length} resultados
      </S.TableFooterRow>
      <S.TableFooterRow>
        <S.Pagination>
          <S.Go
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            type="button"
          >
            <GetIcon name="ChevronLeft" color="black" />
          </S.Go>
          <span>
            Página <strong>{pageIndex + 1}</strong> de{" "}
            <strong>{pageOptions.length}</strong>
          </span>
          <S.Go
            onClick={() => nextPage()}
            disabled={!canNextPage}
            type="button"
          >
            <GetIcon name="ChevronRight" color="black" />
          </S.Go>
        </S.Pagination>
      </S.TableFooterRow>
    </S.TableFooter>
  );
};

export default TableFooter;
